<template>
  <v-row>
    <v-col md="12">
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr class="header-row">
            <th class="header-text header-text-left">ชื่อบริษัท</th>
            <th class="header-text header-text-left">เลขประจำตัวผู้เสียภาษี</th>
            <th class="header-text header-text-right">ดำเนินการ</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="company in companies" :key="company.id" @click="onClickCompanyDetail(company.companyID)" class="tw-cursor-pointer">
            <td>
              <v-avatar size="32" color="#F5F5F5" class="mr-3 font-24 logoText" style="background-color: #fff;">
                <img v-if="company.company.imageLogoUrl"
                     :src="company.company.imageLogoUrl + '=s' + Math.round(30 * getDeviceRatio())"
                     :alt="company.company.nameTH" style="object-fit: contain;">
                <span v-else-if="company.company.nameEN"
                      class="edit-text-avatar">{{ company.company.nameEN[0].toUpperCase() }}</span>
                <span v-else/>
              </v-avatar>
              {{ company.company.nameTH }}
            </td>
            <td>{{ company.company.taxID || "-" }}</td>
            <td class="text-right">
              <v-btn icon color="black" class="button-edit" @click.stop="onClickOpenDialog(company.companyID)" v-if="userCompany.isAdmin">
                <img src="/images/icons/edit_user.svg" alt="edit-user"
                     style="vertical-align: middle; max-width: 26px;"/>
              </v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
       <dialog-edit-company></dialog-edit-company>
      <v-progress-linear indeterminate color="green" :active="loading"></v-progress-linear>
    </v-col>
  </v-row>
</template>

<script>
import {mapState} from "vuex";
import DialogEditCompany from "./dialog-edit-company"
import router from "@/router";

export default {
  name: 'companiesManagement',
  components:{
    DialogEditCompany
  },
  computed: mapState({
    companies: state => state.companies.list,
    loading: state => state.companies.loading,
    isOpenModal: state => state.companies.isOpenModalCompany,
    userCompany: state => state.user.userCompany
  }),
  created() {
    this.$store.dispatch('companies/getList')
    let companyID = this.$route.params.companyId
    if (companyID) {
      this.$store.dispatch('user/getRoleUser', {companyId: companyID})
    }
  },
  methods:{
    onClickOpenDialog: function (companyID){
      if (this.isOpenModal) this.$store.dispatch('companies/setCompanyIDModal', {companyIDModal: ""})
      else this.$store.dispatch('companies/setCompanyIDModal', {companyIDModal: companyID})
      this.$store.dispatch('companies/setIsOpenModalCompany', {isOpenModal: !this.isOpenModal})
    },
    onClickCompanyDetail: function (companyID){
      router.push(`company/${companyID}`)
    },
    getDeviceRatio() {
      return window.devicePixelRatio
    },
  }
}
</script>
<style lang="scss">
.header-row {
  background-color: #f0f0f0 !important;
}

.header-text {
  font-size: 16px !important;
  font-weight: bold !important;
  text-align: center !important;
}

.header-text-left {
  text-align: left !important;
}

.header-text-right {
  text-align: right !important;
}

</style>
